import RestClient from './rest-client'

export default class Provider extends RestClient {
  static get url () {
    return this.apiUrl + '/providers'
  }
  
  static get paramKey () {
    return 'provider'
  }

  static async settings (providerId) {
    const { data } = await this._get(this.apiUrl + '/providers/settings' + '?provider_id=' + providerId)

    return data.data
  }
}
